import React from "react";
import DynamicFont from 'react-dynamic-font';
import { Box,  Button } from "@mui/material";



const CardButton = ({btntype = '',value, onClickHandler= ()=>{}}) =>(
  <>
   <Button onClick={onClickHandler} sx={{width:"7.8rem",padding:'0.5rem 0.5rem',
  border: '2px solid #cf2030', color:btntype==="outlined"?'#cf2030':"#ffffff",background:btntype==="outlined"?"#ffffff":'#cf2030',"&:hover":{background:btntype==="outlined"?"#ffffff":'#cf2030'}}} >
   <Box sx={{maxWidth:"100%",textAlign:"center"}}>
   <DynamicFont content={value} />
   </Box>
    </Button> 
  </>
  )

export default CardButton;
